export default __webpack_public_path__ + "static/favicon-7e06c0d9fd861f658935fada885cc1ef.png";